import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import AsyncSelect from "react-select/async";
import CreatableSelect from 'react-select/creatable';
import { customFetch } from '../apiClient';
import MedicineSaleReceiptModal from "./MedicineSaleReceiptModal";
import DiscountAuthorityDropdown from '../components/DiscountAuthorityDropdown';
import BatchDropdown from '../components/BatchDropdown';

// const customStyles = {
//   menu: (provided) => ({
//     ...provided,
//     zIndex: 9999,
//     backgroundColor: "white",
//     color: "black",
//   }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isFocused ? "#ddd" : "white",
//     color: "black",
//   }),
// };
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '31px', // कम हाइट
    height: '31px',
    fontSize: '13px',
    borderRadius: '4px',
    borderColor: state.isFocused ? '#86b7fe' : '#dee2e6',
    boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '31px',
    padding: '0 6px',
    display: 'flex',
    alignItems: 'center',
  }),
  input: (provided) => ({
    ...provided,
    margin: '0px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '31px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '2px', // एरो छोटा करने के लिए
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '2px',
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '13px',
    backgroundColor: state.isFocused ? "#e9ecef" : "white",
    color: "black",
    padding: '4px 10px',
  }),
};

function initItem() {
  return {
    medID: null,
    medicineName: "",
    medicinecomposition: "",
    category: "",
    companyName: "",
    packSize: "",
    unit: "",
    mrp: "",
    sRate: "",
    gstP: "",
    hsnCode: "",
       gst: 0,  
    batchNo: "",
    availableQty: 0,
      expDate: "",  
    leaf: "",
    piece: "",
    totSaleQtyInPc: 0,
    
    rate: 0,
    taxable: 0,
    cgst: 0,
    sgst: 0,
    grossAmount: 0,
     originalGrossAmount: 0,
    itemDiscount: 0,
    netAmount: 0,
  };
}

const round2 = (v) => (Number.isFinite(v) ? parseFloat(v.toFixed(2)) : 0);
const getToken = () => sessionStorage.getItem("token") || "";

const MedicineSaleForm = () => {
  const [patientType, setPatientType] = useState("MEDICUST");
   const [paymentMode, setPaymentMode] = useState("CASH"); // CASH, UPI, CARD, CREDIT
  const [cashAmount, setCashAmount] = useState(0);
  const [upiAmount, setUpiAmount] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(0);
  const [showReceipt, setShowReceipt] = useState(false);
const [receiptData, setReceiptData] = useState(null);
  const [formMode, setFormMode] = useState("SALE"); 


  const [disAuthority, setDisAuthority] = useState("");
  const [requestedBy, setRequestedBy] = useState("");
  
  // ✅ NEW: Customer entry mode
  const [customerEntryMode, setCustomerEntryMode] = useState("SEARCH"); // SEARCH or NEW


  const [doctors, setDoctors] = useState([]);
const [selectedDoctor, setSelectedDoctor] = useState(null);
const [loadingDoctors, setLoadingDoctors] = useState(false);
  const [customer, setCustomer] = useState({
    id: null, name: "", age: "", gender: "", mobileNo: "", address: "", type: "", uhidNo: "",
    ipdId: null,  // 👈 Ye add karo
  });
  const [batchOptions, setBatchOptions] = useState([]);
  const [loadingBatches, setLoadingBatches] = useState(false);
  
  const [currentItem, setCurrentItem] = useState(initItem);
  const [items, setItems] = useState([]);
  
  // Discount state
  const [discountType, setDiscountType] = useState("PERCENT");
  const [discountValue, setDiscountValue] = useState(0);
  
 
  const [frid] = useState(1);
  const [hid] = useState(1);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

const formRef = useRef(null);
const addButtonRef = useRef(null);
const medicineSelectRef = useRef(null);
    const batchDropdownRef = useRef(null);
    const leafInputRef = useRef(null);
 

useEffect(() => {
  setTimeout(() => {
    // Focus on first input field
    const firstInput = formRef.current?.querySelector(
      'select, input:not([type="hidden"]), .react-select__input input'
    );
    if (firstInput) {
      firstInput.focus();
    }
  }, 300);
}, [])


useEffect(() => {
    const fetchDoctors = async () => {
        try {
            setLoadingDoctors(true);
          // token wali line delete kar dein
            const res = await customFetch(`/Employees/doctors`);
            if (res.ok) {
                const data = await res.json();
                // Label में Name और Department दोनों दिखाएँ ताकि पहचान आसान हो
                const options = data.map(d => ({
                    value: d.id,
                    label: `${d.name} (${d.department?.departmentName || 'No Dept'})`,
                    originalName: d.name,
                    deptName: d.department?.departmentName || ''
                }));
                setDoctors(options);
            }
        } catch (err) {
            console.error("Error fetching doctors:", err);
        } finally {
            setLoadingDoctors(false);
        }
    };
    fetchDoctors();
}, []);


useEffect(() => {
  const handler = (e) => {
    if (formRef.current && e.target.closest("form") === formRef.current) {
      handleKeyDown(e);
    }
  };
  document.addEventListener("keydown", handler);
  return () => document.removeEventListener("keydown", handler);
}, [formMode, items, currentItem]); // ✅ Add dependencies

// 1. UPDATED loadCustomerOptions
  const loadCustomerOptions = async (inputValue) => {
    if (!inputValue || inputValue.trim().length < 1) return [];

    let endpoint = "";
    let queryParam = "term";

    if (patientType === "MEDICUST") { endpoint = "/MediCustDT/search"; }
    else if (patientType === "OPD") { endpoint = "/MediCustDT/searchopd"; }
    else if (patientType === "IPD") { 
      endpoint = "/Ipds/list"; 
      queryParam = "search"; 
    }

    try {
      const res = await customFetch(`${endpoint}?${queryParam}=${encodeURIComponent(inputValue.trim())}`);
      if (!res.ok) return [];
      const data = await res.json();

      return data.map((c) => {
        // 🔥 THE BULLETPROOF FIX: JSON mein kisi bhi case mein ID aaye, ye nikal lega
        const realIpdId = c.ipD_ID || c.IPD_ID || c.ipdId || c.ipd_id || c.id || null;

        return {
          value: patientType === "IPD" ? realIpdId : (c.customerID || c.id),
          label: `${c.customerName || c.name} | UHID: ${c.uhiD_No || c.uhidNo || "NA"} | Age: ${c.age || "NA"} | Mobile: ${c.mobileNo || "NA"}`,
          data: c,
        };
      });
    } catch {
      return [];
    }
  };

  // 2. UPDATED handleCustomerSelect
  const handleCustomerSelect = (selected) => {
    if (!selected) {
      setCustomer({
        id: null, name: "", age: "", gender: "", mobileNo: "", address: "", type: "", uhidNo: "", ipdId: null,
      });
      return;
    }
    
    const c = selected.data;
    
    setCustomer({
      // 👈 Seedha selected.value use karo jo upar nikal chuke hain
      id: selected.value, 
      name: c.name || c.customerName || "",
      age: c.age || "",
      gender: c.gender || "",
      mobileNo: c.mobileNo || "",
      address: c.address || "",
      uhidNo: c.uhiD_No || c.uhidNo || "",
      
      // 🔥 MAIN FIX: Yahan wapas data read mat karo, seedha selected.value set kar do
      ipdId: patientType === "IPD" ? selected.value : null, 
      type: patientType,
    });
  };

  // ✅ NEW: Handle manual customer input
  const handleCustomerInputChange = (e) => {
    const { name, value } = e.target;
    setCustomer((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ NEW: Toggle customer entry mode
  const handleCustomerModeChange = (mode) => {
    setCustomerEntryMode(mode);
setCustomer({
        id: null, name: "", age: "", gender: "", mobileNo: "", address: "", type: patientType, uhidNo: "",
        ipdId: null, // 👈 Ye add karo
      });
    setError("");
  };

  // Medicine search
  const loadMedicineOptions = async (inputValue) => {
    if (!inputValue || inputValue.trim().length < 1) return [];

  try {
     
      const res = await customFetch(`/MedicineDT/search?medicine=${encodeURIComponent(inputValue.trim())}`);
      if (!res.ok) return [];
      const data = await res.json();

      return data.map((m) => ({
        value: m.medID,
        label: m.medicine,
        data: m,
      }));
    } catch {
      return [];
    }
  };

  // Load batch numbers
  const loadBatchNumbers = async (medID) => {
    if (!medID) return;

    setLoadingBatches(true);
try {
   
      const res = await customFetch(`/MedicineBatch/batches/${medID}?hid=1&frid=1`);

      if (!res.ok) {
        setBatchOptions([]);
        return;
      }

      const data = await res.json();
     
      const options = data.map((batch) => ({
        value: batch.batchNo,
        label: `${batch.batchNo} | Avail: ${batch.balance}`,
        balance: batch.balance,
        purchase: batch.purchase,
        sale: batch.sale,
          expDate: batch.expDate,
            mrp: batch.mrp,          // ✅ Add
            sRate: batch.sRate,      // ✅ Add
            saleDis: batch.saleDis ,
      }));

      setBatchOptions(options);
    } catch {
      setBatchOptions([]);
    } finally {
      setLoadingBatches(false);
    }
  };
const handleMedicineSelect = async (selected) => {
    if (!selected) {
        setCurrentItem(initItem());
        setBatchOptions([]);
        return;
    }

    const m = selected.data;
    setCurrentItem(prev => ({
        ...prev,
        medID: m.medID,
        medicineName: m.medicine,
        medicinecomposition: m.mediInUnit,
        category: m.categoryName,
        companyName: m.brandName,
        packSize: m.iUnit,
        unit: m.mUnit,
        gstP: m.gstp,
        hsnCode: m.hsncode,
        mrp: '',
        sRate: '',
        batchNo: '',
        availableQty: 0,
        expDate: ''
    }));

    await loadBatchNumbers(m.medID);
    
    // ✅ NEW - Custom BatchDropdown focus
    setTimeout(() => {
        if (batchDropdownRef.current) {
            batchDropdownRef.current.focus();
        }
    }, 200);
};

  const handleBatchSelect = (e) => {
    const { value } = e.target;
    if (!value) {
      setCurrentItem((prev) => ({ ...prev, batchNo: "", availableQty: 0 ,mrp: '',       
            sRate: '' , expDate: ""}));
      return;
    }

    const batch = batchOptions.find((b) => b.value === value);
    if (batch) {
      setCurrentItem((prev) => ({
        ...prev,
        batchNo: value,
        availableQty: batch.balance,
         expDate: batch.expDate, 
          mrp: batch.mrp,       
            sRate: batch.sRate ,
      }));
    }
  };

  const handleBatchSelectCustom = (batch) => {
    if (!batch) {
        setCurrentItem(prev => ({
            ...prev,
            batchNo: '',
            availableQty: 0,
            expDate: '',
            mrp: '',
            sRate: ''
        }));
        return;
    }

    setCurrentItem(prev => ({
        ...prev,
        batchNo: batch.value,
        availableQty: batch.balance,
        expDate: batch.expDate,
        mrp: batch.mrp,
        sRate: batch.sRate
    }));
    
    // ✅ ADD - Leaf field pe focus
    setTimeout(() => {
        if (leafInputRef.current) {
            leafInputRef.current.focus();
            leafInputRef.current.select();  // ✅ Text select bhi kar do
        }
    }, 100);
};
// ✅ FIXED: Parameter-based formMode
const recalcItem = (item, mode = formMode) => {
  const packSize = parseFloat(item.packSize) || 1;
  const leaf = parseFloat(item.leaf) || 0;
  const piece = parseFloat(item.piece) || 0;
  const sRate = parseFloat(item.sRate) || 0;
  const gstP = parseFloat(item.gstP) || 0;

  const multiplier = mode === "RETURN" ? -1 : 1;
  
  const totSaleQtyInPc = Math.round((leaf * packSize + piece) * multiplier);
  item.totSaleQtyInPc = totSaleQtyInPc;

  const rate = (sRate * Math.abs(totSaleQtyInPc)) / packSize * multiplier;
  const gross = round2(rate);

  const taxable = (gross * 100) / (100 + gstP);
  const cgst = (taxable * gstP) / 200;
  const sgst = (taxable * gstP) / 200;

  item.rate = round2(rate);
  item.taxable = round2(taxable);
  item.cgst = round2(cgst);
  item.sgst = round2(sgst);
  item.grossAmount = gross;
  item.originalGrossAmount = gross;
  item.itemDiscount = 0;
  item.netAmount = gross;
};


const applyItemChange = (item, name, value) => {
  const newItem = { ...item, [name]: value };
  recalcItem(newItem, formMode); // ✅ Pass formMode explicitly
  return newItem;
};

  const handleItemChange = (e) => {
    const { name, value } = e.target;
    const newItem = applyItemChange(currentItem, name, value);
    setCurrentItem(newItem);
  };
const handleAddItem = () => {
  if (!currentItem.medID) {
    setError("Please select a medicine.");
    return;
  }
  if (!currentItem.batchNo) {
    setError("Please select a batch number.");
    return;
  }
  if (!currentItem.expDate) {
    setError("Selected batch has no expiry date — please re-select the batch.");
    return;
  }
  if ((currentItem.leaf !== "" && (isNaN(Number(currentItem.leaf)) || !Number.isInteger(Number(currentItem.leaf)) || Number(currentItem.leaf) < 0)) ||
      (currentItem.piece !== "" && (isNaN(Number(currentItem.piece)) || !Number.isInteger(Number(currentItem.piece)) || Number(currentItem.piece) < 0))) {
    setError("Leaf and Piece must be whole, non-negative numbers.");
    return;
  }
  
  const absQty = Math.abs(Number(currentItem.totSaleQtyInPc));
  
  if (absQty <= 0) {
    setError("Quantity must be greater than 0.");
    return;
  }
  
  if (formMode === "SALE" && absQty > Number(currentItem.availableQty)) {
    setError("Sale quantity cannot exceed available quantity.");
    return;
  }

  setError("");
  
  const itemToAdd = { ...currentItem };
  recalcItem(itemToAdd, formMode); // ✅ Pass formMode explicitly
  
  setItems(prev => [itemToAdd, ...prev]);
  
  setCurrentItem(initItem());
  setBatchOptions([]);
  
  setTimeout(() => {
    if (medicineSelectRef.current) {
      medicineSelectRef.current.focus();
    }
  }, 150);
};


const handleKeyDown = (e) => {
  // FIRST CHECK: AsyncSelect control pe hai?
  const isInsideAsyncSelect = 
    e.target.closest('.react-select__control') ||
    e.target.classList?.contains('react-select__input');
  
  if (isInsideAsyncSelect && e.key === 'Enter') {
    return; // AsyncSelect ke andar hai - skip navigation
  }

  const isReactSelectMenuOpen = document.querySelector('.react-select__menu');
  if (isReactSelectMenuOpen) return;

  // ✅ CHECK 1: BatchDropdown component ke andar hai?
  const activeBatchDropdown = e.target.closest('[data-batch-dropdown="true"]');
  if (activeBatchDropdown) {
    // BatchDropdown apna keyboard navigation handle karega
    return;
  }

  // ✅ CHECK 2: BatchDropdown ka table (panel) open hai?
  const batchPanelOpen = document.querySelector('.batch-dropdown-panel');
  if (batchPanelOpen) {
    // Dropdown panel visible hai - form navigation skip karo
    return;
  }

  // ✅ FIX: tabIndex="-1" wale elements ko EXCLUDE karo
  const focusableElements = formRef.current?.querySelectorAll(
    'input:not([disabled]):not([readonly]):not([type="hidden"]):not([tabindex="-1"]), ' +
    '.react-select__input input:not([disabled]):not([readonly]):not([type="hidden"]), ' +
    'select:not([disabled]):not([tabindex="-1"]), ' +
    'textarea:not([disabled]):not([readonly]), ' +
    'button:not([disabled]):not([tabindex="-1"])'
  );

  if (!focusableElements || focusableElements.length === 0) return;
  const currentIndex = Array.from(focusableElements).indexOf(e.target);

  const isAddButton = 
    e.target.textContent?.includes("Add Medicine") ||
    e.target.classList?.contains('add-medicine-btn') ||
    e.target.closest('button')?.textContent?.includes("Add Medicine");

  if (e.key === "Tab") {
    return; // Browser default
  }

  if (e.key === "Enter") {
    if (isAddButton) {
      e.preventDefault();
      handleAddItem();
      return;
    }

    // Last field = Form submit
    if (currentIndex === focusableElements.length - 1) {
      e.preventDefault();
      e.target.closest("form").requestSubmit();
      return;
    }

    // Otherwise next field
    e.preventDefault();
    const nextIndex = Math.min(focusableElements.length - 1, currentIndex + 1);
    focusableElements[nextIndex]?.focus();
  }
};






  const handleRemoveItem = (index) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
  };

  const handleEditRowToForm = async (index) => {
  const row = items[index];
  if (!row) return;

  setCurrentItem(row);
  setItems(prev => prev.filter((_, i) => i !== index));

  const editItem = { ...row };
  recalcItem(editItem, formMode); // ✅ Pass formMode explicitly

  if (row.medID) {
    await loadBatchNumbers(row.medID);
    
    setTimeout(() => {
      const batch = batchOptions.find(b => b.value === row.batchNo);
      if (batch) {
        setCurrentItem(prev => ({
          ...prev,
          batchNo: row.batchNo,
          mrp: batch.mrp || row.mrp,
          sRate: batch.sRate || row.sRate
        }));
      } else {
        setCurrentItem(prev => ({
          ...prev,
          batchNo: row.batchNo,
          mrp: row.mrp,
          sRate: row.sRate
        }));
      }
    }, 150);
  }

  setError('');
  setSuccess('');
};



const totals = useMemo(() => {
  if (items.length === 0) {
    return {
      totalTaxable: 0,
      totalCgst: 0,
      totalSgst: 0,
      totalGrossAmount: 0,
      totalDiscount: 0,
      totalNetAmount: 0,
      displayItems: [],  // ✅ Table ke liye empty array
    };
  }

  const totalOriginalGross = items.reduce(
    (sum, it) => sum + parseFloat(it.originalGrossAmount || it.grossAmount || 0), 0
  );

  let totalDiscountAmount = 0;
  if (discountType === "PERCENT") {
    totalDiscountAmount = (totalOriginalGross * parseFloat(discountValue || 0)) / 100;
  } else {
    totalDiscountAmount = parseFloat(discountValue || 0);
  }

  const displayItems = items.map((item) => {
    const itemOriginalGross = parseFloat(item.originalGrossAmount || item.grossAmount || 0);
    const gstP = parseFloat(item.gstP) || 0;
    const proportion = totalOriginalGross > 0 ? itemOriginalGross / totalOriginalGross : 0;
    
    const itemDiscount = round2(totalDiscountAmount * proportion);
    const newGross = round2(itemOriginalGross - itemDiscount);
    const newTaxable = round2((newGross * 100) / (100 + gstP));
    const newCgst = round2((newTaxable * gstP) / 200);
    const newSgst = round2((newTaxable * gstP) / 200);

    return {
      ...item,
      itemDiscount,
       grossAmount: itemOriginalGross,
      taxable: newTaxable,
      cgst: newCgst,
      sgst: newSgst,
      netAmount: newGross,
    };
  });

  return {
    totalTaxable: round2(displayItems.reduce((s, it) => s + parseFloat(it.taxable || 0), 0)),
    totalCgst: round2(displayItems.reduce((s, it) => s + parseFloat(it.cgst || 0), 0)),
    totalSgst: round2(displayItems.reduce((s, it) => s + parseFloat(it.sgst || 0), 0)),
    totalGrossAmount: round2(totalOriginalGross),
    totalDiscount: round2(totalDiscountAmount),
    totalNetAmount: round2(displayItems.reduce((s, it) => s + parseFloat(it.netAmount || 0), 0)),
    displayItems,  
  };
}, [items, discountType, discountValue]);


// ✅ PaidAmount calculation
useEffect(() => {
  if (paymentMode === "CASH") {
    const cash = parseFloat(cashAmount) || 0;
    setPaidAmount(cash);
  } else if (paymentMode === "UPI") {
    const upi = parseFloat(upiAmount) || 0;
    setPaidAmount(upi);
  } else if (paymentMode === "BOTH") {
    const cash = parseFloat(cashAmount) || 0;
    const upi = parseFloat(upiAmount) || 0;
    setPaidAmount(cash + upi);
  } else if (paymentMode === "CREDIT") {
    setPaidAmount(0);
  }
}, [paymentMode, cashAmount, upiAmount, totals.totalNetAmount]); 

// ✅ DueAmount calculation
useEffect(() => {
  if (items.length === 0) {
    setDueAmount(0);
    return;
  }
  const totalNet = totals.totalNetAmount;
  const paid = parseFloat(paidAmount) || 0;
  const due = totalNet - paid;
  setDueAmount(due > 0 ? due : 0);
}, [paidAmount, totals.totalNetAmount, items.length]); 

const handleSave = async (e) => {
  e.preventDefault();

  // ✅ NEW: Return mode confirmation
  if (formMode === "RETURN") {
    const confirmReturn = window.confirm(
      "⚠️ Are you sure you want to process RETURN transaction?\nThis will reverse stock quantities."
    );
    if (!confirmReturn) return;
  }

  if (customerEntryMode === "SEARCH" && !customer.id) {
    setError("Please select a customer or switch to 'Add New Customer'.");
    return;
  }

  if (customerEntryMode === "NEW") {
    if (!customer.name || !customer.name.trim()) {
      setError("Customer Name is required.");
      return;
    }
    if (!customer.mobileNo || !customer.mobileNo.trim()) {
      setError("Mobile Number is required.");
      return;
    }
  }

  if (items.length === 0) {
    setError("At least add one medicine.");
    return;
  }

  // ✅ Per-item integrity check (prevents backend save exceptions / DTO errors)
  for (const it of items) {
    const nm = it.medicineName || "a medicine";
    if (!it.medID) { setError("A row has no medicine selected — remove and re-add it."); return; }
    if (!it.batchNo) { setError(`Batch is missing for "${nm}".`); return; }
    if (!it.expDate) { setError(`Expiry date is missing for "${nm}" — re-select its batch.`); return; }
    if (!Number(it.totSaleQtyInPc)) { setError(`Quantity is missing for "${nm}".`); return; }
  }
  if (customerEntryMode === "NEW" && customer.age && isNaN(Number(customer.age))) {
    setError("Age must be a valid number.");
    return;
  }

  setError("");
  setSuccess("");
  setLoading(true);

  try {
    const token = getToken();
    const currentDate = new Date().toISOString().slice(0, 10);
  const isExistingDoctor = selectedDoctor && doctors.some(d => d.value === selectedDoctor.value);

    const payload = {
      frid,
      hid,
      
      // ✅ NEW: Add transaction type
      transactionType: formMode, // "SALE" or "RETURN"
      
      customerId: customerEntryMode === "SEARCH" ? customer.id : null,
      customerType: patientType,
     doctorId: isExistingDoctor ? selectedDoctor.value : null,
       referredBy: selectedDoctor 
        ? (isExistingDoctor ? `${selectedDoctor.originalName} (${selectedDoctor.deptName})` : selectedDoctor.label)
        : (customer.uhidNo ? "Self" : ""),

      customerName: customer.name,
      mobileNo: customer.mobileNo,
      address: customer.address,
      age: customer.age ? parseInt(customer.age) : null,
      gender: customer.gender,

      billDate: currentDate,
      discountType,
      discountValue: parseFloat(discountValue) || 0,
      discountAmount: parseFloat(totals.totalDiscount) || 0,
      
      totalGrossAmount: parseFloat(totals.totalGrossAmount) || 0,
      totalNetAmount: parseFloat(totals.totalNetAmount) || 0,
      ipdId: patientType === "IPD" ? customer.ipdId : null,
      payMode: paymentMode,
      cash: parseFloat(cashAmount) || 0,
      upi: parseFloat(upiAmount) || 0,
      paidAmount: parseFloat(paidAmount) || 0,
      dueAmount: parseFloat(dueAmount) || 0,

      disAuthority: disAuthority,
      requestedBy: requestedBy,

      items: totals.displayItems.map((it) => ({
        medID: parseInt(it.medID) || 0,
        batchNo: it.batchNo || "",
        expDate: it.expDate || "",
        
        // ✅ These will be negative in RETURN mode
        leaf: parseInt(it.leaf) || 0,
        piece: parseInt(it.piece) || 0,
        totSaleQtyInPc: parseInt(it.totSaleQtyInPc) || 0,
        
        rate: parseFloat(it.rate) || 0,
        taxable: parseFloat(it.taxable) || 0,
        cgst: parseFloat(it.cgst) || 0,
        sgst: parseFloat(it.sgst) || 0,
        gstP: parseFloat(it.gstP) || 0,
       
        grossAmount: parseFloat(it.originalGrossAmount) || parseFloat(it.grossAmount) || 0,
        itemDiscount: parseFloat(it.itemDiscount) || 0,
        netAmount: parseFloat(it.netAmount) || 0,
        sRate: parseFloat(it.sRate) || 0,
        mrp: parseFloat(it.mrp) || 0,
        
        hsnCode: it.hsncode || it.hsnCode || "",
      })),
    };

   const res = await customFetch(`/MedicineSale/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const txt = await res.text();
      throw new Error(txt || "Failed to save transaction.");
    }

    const data = await res.json();

    // ✅ Dynamic success message
    setSuccess(
      `${formMode === "RETURN" ? "Return" : "Sale"} saved successfully! Bill No: ${data.billNo} | Customer: ${data.customerName}`
    );

    // Receipt logic (same as before)
 try {
      // recToken wali line delete kar dein
      const recRes = await customFetch(`/MedicineSale/receipt/${data.billNo}`);

      if (!recRes.ok) {
        throw new Error("Failed to load receipt data.");
      }

      const receiptData = await recRes.json();
      setReceiptData(receiptData);
      setShowReceipt(true);
    } catch (err) {
      console.error("Receipt load error:", err);
    }

    // ✅ Reset form (add formMode reset)
    setItems([]);
    setCurrentItem(initItem());
    setCustomer({
      id: null,
      name: "",
      age: "",
      gender: "",
      mobileNo: "",
      address: "",
      type: "",
      uhidNo: "",
       ipdId: null ,
    });
    setDiscountValue(0);
    setCashAmount(0);
    setUpiAmount(0);
    setPaidAmount(0);
    setDueAmount(0);
    setDisAuthority("");
    setRequestedBy("");
    setCustomerEntryMode("SEARCH");
    setFormMode("SALE"); // ✅ Reset to SALE mode

    setTimeout(() => {
      const firstInput = formRef.current?.querySelector(
        'select, input:not([type="hidden"]), .react-select__input input'
      );
      if (firstInput) {
        firstInput.focus();
      }
    }, 300);

  } catch (err) {
    setError(err.message || "Error occurred");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="container-fluid mt-0 ms-compact">
      <div className="card shadow">
        <div className={`card-header py-2 text-white ${
    formMode === "SALE" ? "bg-primary" : "bg-danger"
  }`}>
            <h6 className="mb-0 fw-bold">
      {formMode === "SALE" ? "💊 Medicine Sale" : "↩️ Medicine Return"}
    </h6>
        </div>
        <div className="card-body fs-7">
          {error && <div className="alert alert-danger py-2">{error}</div>}
          {success && <div className="alert alert-success py-2">{success}</div>}

          <form ref={formRef} onSubmit={handleSave}>
            {/* Customer Details */}
            <div className="border p-3 mb-3 rounded bg-light">
              
              <div className="row mb-1 mt-0">
           
                      <div className="col-md-1 ">
                  <label className="form-label small mt-0 mb-0">Patient Type</label>
                  <select
                    className="form-select form-select-sm"
                    value={patientType}
                    onChange={(e) => {
                      setPatientType(e.target.value);
                      setCustomer({
                        id: null,
                        name: "",
                        age: "",
                        gender: "",
                        mobileNo: "",
                        address: "",
                        type: "",
                        uhidNo: "",
                      });
                    }}
                  >
                    <option value="MEDICUST">MCDC</option>
                    <option value="OPD">OPD</option>
                    <option value="IPD">IPD</option>
                  </select>
                </div>

                {/* ✅ NEW: Customer Entry Mode Toggle */}
                <div className="col-md-3">
                  <label className="form-label small mb-0 mt-0">Customer Entry</label>
                  <div className="btn-group w-100" role="group">
                    <button
                      type="button"
                      className={`btn btn-sm ${
                        customerEntryMode === "SEARCH"
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      onClick={() => handleCustomerModeChange("SEARCH")}
                    >
                      🔍 Search Existing
                    </button>
                    <button
                      type="button"
                      className={`btn btn-sm ${
                        customerEntryMode === "NEW"
                          ? "btn-success"
                          : "btn-outline-success"
                      }`}
                      onClick={() => handleCustomerModeChange("NEW")}
                    >
                      ➕ Add New
                    </button>
                  </div>
                  
                </div>

                <div className="col-md-2">
  <label className="form-label small mb-0 mt-0">Transaction Type</label>
  <div className="btn-group w-100" role="group">
    <button
      type="button"
      className={`btn btn-sm ${
        formMode === "SALE" ? "btn-success" : "btn-outline-success"
      }`}
      onClick={() => setFormMode("SALE")}
      tabIndex="-1"
    >
      💊 Sale
    </button>
    <button
      type="button"
      className={`btn btn-sm ${
        formMode === "RETURN" ? "btn-danger" : "btn-outline-danger"
      }`}
      onClick={() => setFormMode("RETURN")}
      tabIndex="-1"
    >
      ↩️ Return
    </button>
  </div>
</div>
                 
 {/* ✅ UHID, Gender, Mobile (only in SEARCH mode) */}
    {customerEntryMode === "SEARCH" && (
      <>
        <div className="col-md-2">
          <label className="form-label small mb-0">UHID</label>
          <input
            className="form-control form-control-sm"
            value={customer.uhidNo}
            readOnly
          />
        </div>

        <div className="col-md-1">
          <label className="form-label small mb-0">Gender</label>
          <input
            className="form-control form-control-sm"
            value={customer.gender}
            readOnly
          />
        </div>

        <div className="col-md-2">
          <label className="form-label small mb-0">Mobile No</label>
          <input
            className="form-control form-control-sm"
            value={customer.mobileNo}
            readOnly
          />
        </div>
        
                  
                    <div className="col-md-1">
                      <label className="form-label small mb-0">Age</label>
                      <input
                        className="form-control form-control-sm"
                        value={customer.age}
                        readOnly
                      />
                    </div>
      </>
    )}
             </div>
                
         

              {/* ✅ SEARCH MODE */}
              {customerEntryMode === "SEARCH" && (
                <>
                  <div className="row mb-1">
             

                    <div className="col-md-3">
                      <label className="form-label small mb-0">
                        Search Patient/Customer <span className="text-danger">*</span>
                      </label>
                      <AsyncSelect
                        key={patientType}
                        cacheOptions
                        loadOptions={loadCustomerOptions}
                        onChange={handleCustomerSelect}
                        placeholder="Type name/mobile to search..."
                        isClearable
                        styles={customStyles}
                        value={
                          customer.id
                            ? {
                                value: customer.id,
                                label: `${customer.name} | UHID: ${customer.uhidNo}`,
                              }
                            : null
                        }
                      />
                    </div>

                     <div className="col-md-3 ">
                      <label className="form-label small mb-0">Name</label>
                      <input
                        className="form-control form-control-sm"
                        value={customer.name}
                        readOnly
                      />
                    </div>
                       
                    <div className="col-md-3">
                      <label className="form-label small mb-0">Address</label>
                      <input
                        className="form-control form-control-sm"
                        value={customer.address}
                        readOnly
                      />
                    </div>
                    <div className="col-md-3">
      <label className="form-label small mb-0">Referred By (Doctor)</label>
      <CreatableSelect
        isClearable
        options={doctors}
        value={selectedDoctor}
        onChange={(opt) => setSelectedDoctor(opt)}
        placeholder="Select or Type Doctor..."
        formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
        isLoading={loadingDoctors}
        styles={customStyles}
      />
    </div>
                    

                  </div>

         
                </>
              )}

              {/* ✅ NEW MODE - Manual Entry */}
              {customerEntryMode === "NEW" && (
                <>
                

                  <div className="row mb-1 mt-0">
                    <div className="col-md-3">
                      <label className="form-label small mb-0 mt-0">
                        Customer Name <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control form-control-sm"
                        name="name"
                        value={customer.name}
                        onChange={handleCustomerInputChange}
                        placeholder="Enter full name"
                      />
                    </div>

                    <div className="col-md-2">
                      <label className="form-label small mb-0">
                        Mobile Number <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control form-control-sm"
                        name="mobileNo"
                        value={customer.mobileNo}
                        onChange={handleCustomerInputChange}
                        placeholder="10-digit mobile"
                        maxLength="10"
                      />
                    </div>

                    <div className="col-md-1">
                      <label className="form-label small mb-0">Age</label>
                      <input
                        className="form-control form-control-sm"
                        name="age"
                        type="number"
                        value={customer.age}
                        onChange={handleCustomerInputChange}
                        placeholder="Age"
                      />
                    </div>

                    <div className="col-md-2">
                      <label className="form-label small mb-0">Gender</label>
                      <select
                        className="form-select form-select-sm"
                        name="gender"
                        value={customer.gender}
                        onChange={handleCustomerInputChange}
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                

                
                    <div className="col-md-4">
                      <label className="form-label small mb-0">Address</label>
                      <input
                        className="form-control form-control-sm"
                        name="address"
                        value={customer.address}
                        onChange={handleCustomerInputChange}
                        placeholder="Enter complete address"
                      />
                    </div>

         
                   </div>

                   <div className='row mb-1'>
                               <div className="col-md-3">
                        <label className="form-label small mb-0">Referred By (Doctor)</label>
                        <CreatableSelect
                          isClearable
                          options={doctors}
                          value={selectedDoctor}
                          onChange={(opt) => setSelectedDoctor(opt)}
                          placeholder="Select or Type..."
                          formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                          isLoading={loadingDoctors}
                          styles={customStyles}
                        />
                      </div>
                   </div>
                </>
              )}
            </div>
                

            {/* Medicine Search */}
            <div className="border p-2 mb-1 rounded">
         
              
              <div className="row mb-1">
               <div className="col-md-4">
  <label className="form-label small mb-0 mt-0">
    💊 Search Medicine <span className="text-danger">*</span>
  </label>
  
  <div 
    onKeyDown={(e) => {
      if (e.key === 'Enter') {
        // ✅ CHECK 1: Dropdown open hai?
        const menu = document.querySelector('.react-select__menu');
        
        if (menu) {
          // Dropdown OPEN - selection ho rahi hai
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        
        // ✅ CHECK 2: Empty field hai aur items already added hain?
        if (!currentItem.medID && items.length > 0) {
          // User payment pe jana chahta hai - normal flow
          // DON'T PREVENT - let handleKeyDown move to next field
          return;
        }
        
        // ✅ CHECK 3: Medicine selected hai?
        if (currentItem.medID) {
          // Selected hai - batch field pe jana chahiye
          // DON'T PREVENT - let handleKeyDown move to next field
          return;
        }
        
        // ✅ Default: Prevent (safety)
        e.preventDefault();
        e.stopPropagation();
      }
    }}
  >
    <AsyncSelect
      ref={medicineSelectRef}
      cacheOptions
      loadOptions={loadMedicineOptions}
      onChange={handleMedicineSelect}
      placeholder="Start typing medicine name..."
      isClearable
      styles={customStyles}
      value={
        currentItem.medID
          ? {
              value: currentItem.medID,
              label: currentItem.medicineName,
            }
          : null
      }
    />
  </div>
</div>

                

                <div className="col-md-3">
                  <label className="form-label small  mb-0 mt-0">Composition</label>
                  <input
                    className="form-control form-control-sm"
                    value={currentItem.medicinecomposition}
                    readOnly
                  />
                </div>

                <div className="col-md-1">
                  <label className="form-label small  mb-0 mt-0">Category</label>
                  <input
                    className="form-control form-control-sm"
                    value={currentItem.category}
                    readOnly
                  />
                </div>
                    <div className="col-md-2">
                  <label className="form-label small  mb-0 mt-0">Company</label>
                  <input
                    className="form-control form-control-sm"
                    value={currentItem.companyName}
                    readOnly
                  />
                </div>

                <div className="col-md-1">
                  <label className="form-label small  mb-0 mt-0">Pack Size</label>
                  <input
                    className="form-control form-control-sm"
                    value={currentItem.packSize}
                    readOnly
                  />
                </div>
            <div className="col-md-1">
                  <label className="form-label small  mb-0 mt-0">GST %</label>
                  <input
                    className="form-control form-control-sm"
                    value={currentItem.gstP}
                    readOnly
                  />
                </div>
              </div>

              <div className="row g-2 mb-1">
            

            

               

                
              

               <div className="col-md-2">
              <label className="form-label small  mb-0 mt-0">HSN Code</label>
              <input
                className="form-control form-control-sm"
                value={currentItem.hsnCode || currentItem.hsncode || ""}
                readOnly
              />
            </div>


                {/* Batch selection */}
                {currentItem.medID && (
                  <>
              <div className="col-md-2">
        <label className="form-label small mt-0 mb-0">
            Batch No <span className="text-danger">*</span>
        </label>
        <BatchDropdown
          ref={batchDropdownRef}
            options={batchOptions}
            value={currentItem.batchNo}
            onChange={handleBatchSelectCustom}
            loading={loadingBatches}
            disabled={batchOptions.length === 0}
        />
    </div>


                            <div className="col-md-1">
                  <label className="form-label small  mb-0 mt-0">MRP</label>
                  <input
                    className="form-control form-control-sm bg-info"
                    value={currentItem.mrp}
                    readOnly
                  />
                </div>
                 <div className="col-md-1">
                  <label className="form-label small  mb-0 mt-0">Sale Rate</label>
                  <input
                    className="form-control form-control-sm bg-info"
                    value={currentItem.sRate}
                    readOnlys
                  />
                </div>

                    <div className="col-md-2">
      <label className="form-label small mt-0 mb-0">Expiry Date</label>
      <input
        className="form-control form-control-sm bg-warning"
        value={
          currentItem.expDate 
            ? new Date(currentItem.expDate).toLocaleDateString('en-GB')
            : ""
        }
        readOnly
      />
    </div>

                    <div className="col-md-1">
                      <label className="form-label small mt-0 mb-0">Available Qty</label>
                      <input
                        className="form-control form-control-sm bg-warning"
                        value={currentItem.availableQty}
                        readOnly
                      />
                    </div>
                  </>
                )}
              </div>

              {/* Leaf & Piece input */}
              {currentItem.batchNo && (
                <div className="row g-2 mb-1">
                  <div className="col-md-1">
  <label className="form-label small mt-0 mb-0">
    Leaf <span className="text-danger">*</span>
  </label>
  <input
    ref={leafInputRef}
    className={`form-control form-control-sm ${
      formMode === "RETURN" ? "bg-danger bg-opacity-25 text-danger fw-bold" : ""
    }`}
    name="leaf"
    value={currentItem.leaf}
    onChange={handleItemChange}
    placeholder={formMode === "RETURN" ? "Return qty" : "Sale qty"}
  />
</div>

{/* ✅ UPDATE: Piece input with visual indication */}
<div className="col-md-1">
  <label className="form-label small mt-0 mb-0">
    Piece <span className="text-danger">*</span>
  </label>
  <input
    className={`form-control form-control-sm ${
      formMode === "RETURN" ? "bg-danger bg-opacity-25 text-danger fw-bold" : ""
    }`}
    name="piece"
    value={currentItem.piece}
    onChange={handleItemChange}
    placeholder={formMode === "RETURN" ? "Return pcs" : "Sale pcs"}
  />
</div>
                  <div className="col-md-2">
                    <label className="form-label small  mt-0 mb-0">Total Qty (Pcs)</label>
                    <input
                      className="form-control form-control-sm bg-info"
                      value={currentItem.totSaleQtyInPc}
                      readOnly
                    />
                  </div>

                  <div className="col-md-1">
                    <label className="form-label small  mt-0 mb-0">Rate</label>
                    <input
                      className="form-control form-control-sm"
                      value={currentItem.rate}
                      readOnly
                    />
                  </div>

                  <div className="col-md-1">
                    <label className="form-label small  mt-0 mb-0">Taxable</label>
                    <input
                      className="form-control form-control-sm"
                      value={currentItem.taxable}
                      readOnly
                    />
                  </div>

              
                   
                  <div className="col-md-1">
                    <label className="form-label small mt-0 mb-0">GST</label>
                    <input
                      className="form-control form-control-sm"
                      value={(Number(currentItem.cgst || 0) + Number(currentItem.sgst || 0)).toFixed(2)}
                      readOnly
                    />
                  </div>

                  <div className="col-md-2">
                    <label className="form-label small  mt-0 mb-0">Gross Amount</label>
                    <input
                      className="form-control form-control-sm"
                      value={currentItem.grossAmount}
                      readOnly
                    />
                  </div>

         
               {/* Add Medicine Button */}
              <div className="col-md-2 d-flex align-items-end">
                <button
                  ref={addButtonRef}
                  type="button"
                  className="btn btn-success btn-sm w-100 add-medicine-btn"
                  onClick={handleAddItem}
                  onKeyDown={(e) => {  // ✅ ADD THIS
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleAddItem();
                    }
                  }}
                >
                  ➕ Add Medicine
                </button>
              </div>


                </div>
              )}
            </div>


       
            <div className="table-responsive mb-1 mt-0" style={{ fontSize: "0.8rem" }}>
              <table className="table table-sm table-bordered table-hover align-middle text-center">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Medicine</th>
                    <th>Batch</th>
                    <th>Exp Date</th>
                    <th>Leaf</th>
                    <th>Piece</th>
                    <th>Tot Qty</th>
                    <th>Rate</th>
                    <th>Taxable</th>
                     <th>GST</th> 
                   
                    <th>Gross</th>
                    <th className="bg-warning text-dark">Discount</th>
                    <th className="bg-success text-white">Net</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
  {totals.displayItems?.length === 0 ? (
    <tr>
      <td colSpan="14" className="text-muted">No items added.</td>
    </tr>
  ) : (
    totals.displayItems.map((it, idx) => ( 
      <tr key={idx}>
        <td>{idx + 1}</td>
        <td className="text-start">{it.medicineName}</td>
        <td>{it.batchNo}</td>
         <td>
          {it.expDate 
            ? new Date(it.expDate).toLocaleDateString('en-GB')
            : "-"}
        </td>
        <td>{it.leaf}</td>
        <td>{it.piece}</td>
        <td>{it.totSaleQtyInPc}</td>
        <td>{Number(it.rate || 0).toFixed(2)}</td> 
        <td>{Number(it.taxable || 0).toFixed(2)}</td>
  
          <td>
              {(Number(it.cgst || 0) + Number(it.sgst || 0)).toFixed(2)}
            </td>
        <td>{Number(it.grossAmount || 0).toFixed(2)}</td>
        <td className="bg-warning fw-bold">
          {Number(it.itemDiscount || 0).toFixed(2)} 
        </td>
        <td className="bg-success text-white fw-bold">
          {Number(it.netAmount || 0).toFixed(2)}  
        </td>
        <td>
          <button
            type="button"
            className="btn btn-sm btn-primary me-1"
            onClick={() => handleEditRowToForm(idx)}
            title="Edit"
            tabIndex="-1"
          >
            ✎
          </button>
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => handleRemoveItem(idx)}
            title="Delete"
            tabIndex="-1"
          >
            🗑
          </button>
        </td>
      </tr>
    ))
  )}
</tbody>

              </table>
            </div>

            {/* Summary Section */}
            {items.length > 0 && (
              <>
              <div className="mt-1 p-2 border rounded bg-info bg-opacity-10">
         
                <div className="row mb-0 mt-0">
                  <div className="col-md-1">
                    <label className="form-label small mt-0 mb-0">Total Taxable</label>
                    <input
                      className="form-control form-control-sm"
                      value={totals.totalTaxable.toFixed(2)}
                      readOnly
                    />
                  </div>
                  <div className="col-md-1">
                    <label className="form-label small mt-0 mb-0">Total CGST</label>
                    <input
                      className="form-control form-control-sm"
                      value={totals.totalCgst.toFixed(2)}
                      readOnly
                    />
                  </div>
                  <div className="col-md-1">
                    <label className="form-label small mt-0 mb-0">Total SGST</label>
                    <input
                      className="form-control form-control-sm"
                      value={totals.totalSgst.toFixed(2)}
                      readOnly
                    />
                  </div>
                  <div className="col-md-1">
                    <label className="form-label small mt-0 mb-0">Gross Amount</label>
                    <input
                      className="form-control form-control-sm"
                      value={totals.totalGrossAmount.toFixed(2)}
                      readOnly
                    />
                  </div>

                  {/* Discount fields */}
                  <div className="col-md-2">
                    <label className="form-label small mt-0 mb-0">Discount Type</label>
                    <select
                      className="form-select form-select-sm"
                      value={discountType}
                      onChange={(e) => setDiscountType(e.target.value)}
                    >
                      <option value="PERCENT">Percent (%)</option>
                      <option value="AMOUNT">Amount (₹)</option>
                    </select>
                  </div>

                  <div className="col-md-1">
                    <label className="form-label small mt-0 mb-0">
                      Discount {discountType === "PERCENT" ? "%" : "₹"}
                    </label>
                    <input
                      className="form-control form-control-sm"
                      type="number"
                      value={discountValue}
                      onChange={(e) => setDiscountValue(e.target.value)}
                      min="0"
                    />
                  </div>
                       <div className="col-md-2">
                    <label className="form-label small fw-bold mt-0 mb-0">
                      Total Discount
                    </label>
                    <input
                      className="form-control form-control-sm fw-bold bg-warning"
                      value={totals.totalDiscount.toFixed(2)}
                      readOnly
                    />
                  </div>
                   <div className="col-md-2">
                    <label className="form-label small fw-bold mt-0 mb-0">
                      Net Amount (Payable)
                    </label>
                    <input
                      className="form-control form-control-sm fw-bold bg-success text-white"
                      value={totals.totalNetAmount.toFixed(2)}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row">
                <div className="col-md-2">
                      <label className="form-label small mt-0 mb-0">
                        Payment Mode <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select form-select-sm"
                        value={paymentMode}
                        onChange={(e) => {
                          setPaymentMode(e.target.value);
                          if (e.target.value === "CREDIT") {
                            setPaidAmount(0);
                            setCashAmount(0);
                            setUpiAmount(0);
                          }
                        }}
                      >
                        <option value="CASH">Cash</option>
                        <option value="UPI">UPI</option>
                        <option value="BOTH">Cash + UPI</option>
                        <option value="CARD">Card</option>
                        <option value="CREDIT">Credit (Due)</option>
                      </select>
                    </div>

                    {/* Cash Amount */}
                    {(paymentMode === "CASH" || paymentMode === "BOTH") && (
                      <div className="col-md-1">
                        <label className="form-label small mt-0 mb-0">
                          Cash Amount <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control form-control-sm"
                          type="number"
                          value={cashAmount}
                          onChange={(e) => setCashAmount(e.target.value)}
                          min="0"
                          step="0.01"
                        />
                      </div>
                    )}

                    {/* UPI Amount */}
                    {(paymentMode === "UPI" || paymentMode === "BOTH") && (
                      <div className="col-md-1">
                        <label className="form-label small mt-0 mb-0">
                          UPI Amount <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control form-control-sm"
                          type="number"
                          value={upiAmount}
                          onChange={(e) => setUpiAmount(e.target.value)}
                          min="0"
                          step="0.01"
                        />
                      </div>
                    )}

                    {/* Total Paid */}
                    <div className="col-md-2">
                      <label className="form-label small fw-bold mt-0 mb-0">
                        Total Paid Amount
                      </label>
                      <input
                        className="form-control form-control-sm fw-bold bg-primary text-white"
                        value={paidAmount.toFixed(2)}
                        readOnly
                      />
                    </div>

                    {/* Due Amount */}
                    <div className="col-md-1">
                      <label className="form-label small fw-bold mt-0 mb-0">
                        Due Amount
                      </label>
                      <input
                        className={`form-control form-control-sm fw-bold ${
                          dueAmount > 0 ? "bg-danger text-white" : "bg-success text-white"
                        }`}
                        value={dueAmount.toFixed(2)}
                        readOnly
                      />
                    </div>
                           {/* Discount Authority & Requested By */}
                   {discountValue > 0 && (
                    <>
                      
{/* 
                        <div className="col-md-3 ">
                        <label className="form-label small mt-0 mb-0">
                          Discount Authority <span className="text-danger">*</span>
                        </label>
                        <DiscountAuthorityDropdown
                          value={disAuthority}
                          onChange={(e) => setDisAuthority(e.target.value)}
                          name="discountAuthority"
                          
                        />
                      </div> */}

                      <div className="col-md-3 mt-2">
<DiscountAuthorityDropdown
  value={disAuthority}
  // ✅ FIX: Check karein ki option select hua hai ya clear (null)
  onChange={(selectedOption) => setDisAuthority(selectedOption ? selectedOption.value : "")} 
  name="disAuthority"
  label="Discount Authority"
  showLabel={true}
  placeholder="Select Authority"
/>
</div>

                        <div className="col-md-2">
                          <label className="form-label small mt-0 mb-0">
                            Requested By
                          </label>
                          <input
                            className="form-control form-control-sm"
                            value={requestedBy}
                            onChange={(e) => setRequestedBy(e.target.value)}
                            placeholder="Staff name"
                          />
                        </div>
                        </>
                          )}
                    
              </div>
              </div>
             
        </>
      )}


           {/* ✅ UPDATE: Dynamic submit button */}
<div className="text-end mt-4">
  <button
    type="submit"
    className={`btn px-5 ${
      formMode === "SALE" ? "btn-success" : "btn-danger"
    }`}
    disabled={loading || items.length === 0}
  >
    {loading 
      ? "💾 Saving..." 
      : formMode === "RETURN" 
        ? "↩️ Process Return" 
        : "💾 Save Sale"
    }
  </button>
</div>

          </form>


    <MedicineSaleReceiptModal
  show={showReceipt}
  receipt={receiptData}
  onClose={() => setShowReceipt(false)}
  onPrint={() => window.print()}
/>

      {/* ✅ Compact UI (only affects this form via .ms-compact) */}
      <style>{`
        .ms-compact .form-label { font-size: 0.72rem; margin-bottom: 1px; font-weight: 600; }
        .ms-compact .form-control, .ms-compact .form-control-sm,
        .ms-compact .form-select, .ms-compact .form-select-sm {
          min-height: 30px; height: 30px; padding: 2px 8px; font-size: 0.8rem;
        }
        .ms-compact .row { --bs-gutter-y: 0.4rem; }
        .ms-compact .border.p-3 { padding: 0.65rem !important; }
        .ms-compact .mb-3 { margin-bottom: 0.6rem !important; }
        .ms-compact .card-body { padding: 0.75rem; }
      `}</style>


        </div>
      </div>
    </div>
  );
};

export default MedicineSaleForm;
